import { getMaxLengthValidator, getMaxLengthValidationError } from "./rawValidators";
const validateMaxLength = (value, maxLength, fieldName) => getMaxLengthValidator(maxLength)(value) || (typeof fieldName === 'string' ? getMaxLengthValidationError(fieldName, maxLength) : false);

/** For react-hook-form library. */
export const maxLengthValidation = (_maxLength, fieldName) => ({
  validate: {
    maxLength: value => validateMaxLength(value, _maxLength, fieldName)
  }
});